module.exports = __webpack_public_path__ + "static/img/no_data.a2c64c0.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/no_data.svg
// module id = Ywrd
// module chunks = 0